import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var text = theme.text;
export var commonHeading = /*#__PURE__*/css(["", ";", ";"], fontSize(text.HEADING.XS), mediaQuery({
  min: minBreakpoints.L
}, css(["", ";"], fontSize(text.HEADING.SM))));